/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import { render } from 'react-dom';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import createAllI18nProvider from 'I18n/init/providers/createAllI18nProvider';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import 'I18n/init/data/baseLocales';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
// this file will be loaded for all languages, so that the user can freely switch languages
import allLang from 'i2l?query=sporks!../lang/onboarding/en.lyaml';
import { RhumbProvider } from 'react-rhumb';
import rhumbHistoryAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { enableRejectionTracking } from 'hs-promise-rejection-tracking';
import userInfo from 'hub-http/userInfo';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import ContentRoutes from 'ContentUtils/Routes';
import * as AppActions from './actions/AppActions';
import LoadingPage from './components/utility/LoadingPage';
import { SERVICE_KNOWLEDGE_ACCESS_SCOPE } from './constants/ScopesConstants';
import configureStore from './utils/configureStore';
import createHistory from './utils/createHistory';
import previewController from './utils/previewController';
import { getRootUrl, getUpgradeUrl } from './routing/utils/externalUrls';
import Routes from './routing/components/Routes';
import { knowledgeBaseMigrationReport } from './migration-handler/singleton/migrationHandler';
import { isUngatedForKnowledgeBaseV3_1 } from './utils/gatesUtils';
import DFCProvider from './providers/DFCProvider';
import { jsx as _jsx } from "react/jsx-runtime";
enableRejectionTracking();
export default class App {
  start() {
    const standardI18nProvider = createStandardI18nProvider();
    const allI18nProvider = createAllI18nProvider();
    const langAvailable = initAppTranslations([standardI18nProvider.register(lang), registerAllData(standardI18nProvider), allI18nProvider.register(allLang)]);
    userInfo().then(({
      user,
      portal,
      gates
    }) => {
      standardI18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal.timezone
      });
      langAvailable.then(() => {
        if (!user.scopes.includes(SERVICE_KNOWLEDGE_ACCESS_SCOPE)) {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
          window.location = getUpgradeUrl();
          return;
        }
        const startEverything = () => {
          const history = createHistory(getRootUrl());
          ContentRoutes.init(gates);
          const store = configureStore({}, {
            history
          });
          store.dispatch(AppActions.start({
            user,
            gates,
            portal
          }));
          previewController.setStore(store);
          render( /*#__PURE__*/_jsx(RhumbProvider
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'PartialR... Remove this comment to see the full error message
          , {
            config: rhumbConfig,
            history: rhumbHistoryAdapter(history),
            children: /*#__PURE__*/_jsx(DFCProvider, {
              children: /*#__PURE__*/_jsx(Provider, {
                store: store,
                children: /*#__PURE__*/_jsx(Router, {
                  history: history,
                  children: /*#__PURE__*/_jsx(Routes, {})
                })
              })
            })
          }), document.getElementsByClassName('page')[0]);
        };
        if (isUngatedForKnowledgeBaseV3_1(gates)) {
          knowledgeBaseMigrationReport().then(() => {
            startEverything();
          }).catch(this.handleLoadingError);
        } else {
          startEverything();
        }
      });
    }).catch(e => {
      standardI18nProvider.setLocale({
        locale: 'en-us'
      });
      this.handleLoadingError(e);
    });
  }
  handleLoadingError(error) {
    render( /*#__PURE__*/_jsx(LoadingPage, {
      error: error
    }), document.getElementsByClassName('page')[0]);
  }
}